import { render, staticRenderFns } from "./Callbacks.vue?vue&type=template&id=5b5c78d2&"
import script from "./Callbacks.vue?vue&type=script&lang=js&"
export * from "./Callbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports